import { buildingsByProducedResourceId } from "../../balancing/types/buildingsByProducedResourceId";
import { createPathSelectBuildingInBuildMenu } from "./createPathSelectBuildingInBuildMenu";
export var pathSelectBuildingInBuildMenuByResourceId = function (action, state$, deps) {
    return createPathSelectBuildingInBuildMenu(function () {
        if (action.taskType && action.taskType.resourceId) {
            var buildingIds = buildingsByProducedResourceId.get(action.taskType.resourceId);
            return buildingIds ? buildingIds[0] : 0;
        }
        else {
            return 0;
        }
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathSelectBuildingInBuildMenuByResourceId.ts
// module id = 899
// module chunks = 3